// extracted by mini-css-extract-plugin
export var lazyBlur = "lazy-blur-module--lazyBlur--1JBeQ";